import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, Form, FormControl, InputGroup, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import CreateCategory from "../components/categoryComponents/CreateCategory";
import EditCategory from "../components/categoryComponents/EditCategory";
import actions from "../redux/actions/categoriesActions";

function CategoriesPage() {
  const token = useSelector((state) => state.user.access_token);
  const categories = useSelector((state) => state.categories);
  const [category, setCategory] = useState({});
  const [categoryToDestroy, setCategoryToDestroy] = useState({});
  const [search, setSearch] = useState("");
  const dispatch = useDispatch();
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showDestroy, setShowDestroy] = useState(false);

  const handleShowCreate = () => setShowCreate(true);
  const handleShowEdit = (category) => {
    setCategory(category);
    setShowEdit(true);
  };

  const handleShowDestroy = (category) => {
    setCategoryToDestroy(category);
    setShowDestroy(true);
  };
  const handleCloseDestroy = () => setShowDestroy(false);

  const getCategories = async () => {
    const response = await axios({
      method: "GET",
      url: process.env.REACT_APP_API_URL + "/api/categories",
      headers: { Authorization: `Bearer ${token}` },
    });
    dispatch(actions.storeCategories(response.data));
  };
  try {
    useEffect(() => {
      getCategories();
    }, []);
  } catch (error) {
    console.log("Error: ", error);
  }

  const handleDestroyCategory = async () => {
    const response = await axios({
      method: "DELETE",
      url:
        process.env.REACT_APP_API_URL +
        `/api/categories/${categoryToDestroy.id}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    dispatch(actions.destroyCategory(categoryToDestroy.id));
    setShowDestroy(false);
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    const response = await axios({
      method: "GET",
      url: process.env.REACT_APP_API_URL + `/api/categories?search=${search}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    dispatch(actions.storeCategories(response.data));
  };

  return (
    <>
      <div className="animate__animated animate__fadeIn d-flex flex-column w-100 dashboard-pages">
        <h1 className="h3 ms-3 mb-4">Categories</h1>
        <div className="d-flex justify-content-between mx-3 mb-3">
          <Form
            className="d-flex search-tables"
            onSubmit={(e) => handleSearch(e)}
          >
            <InputGroup>
              <FormControl
                placeholder="Search category"
                aria-label="Search category"
                name="search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <Button variant="outline-success" type="submit">
                <i className="bi bi-search"></i>
              </Button>
              <Button
                variant="outline-danger"
                onClick={() => {
                  getCategories();
                  setSearch("");
                }}
              >
                <i className="bi bi-x-lg"></i>
              </Button>
            </InputGroup>
          </Form>
          <Button
            variant="success"
            onClick={handleShowCreate}
            className="add-btn fs-5 ms-auto"
          >
            New Category
          </Button>
        </div>
        <div className="table-container w-100">
          {categories.length > 0 ? (
            <table className="table table-striped table-hover align-middle border rounded shadow">
              <thead>
                <tr>
                  <th className="ps-3">ID</th>
                  <th>Name</th>
                  <th>Slug</th>
                  <th>CreatedAt</th>
                  <th>updatedAt</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {categories.map((category) => (
                  <tr key={category.id}>
                    <td className="fw-bold ps-3">{category.id}</td>
                    <td>{category.name}</td>
                    <td>{category.slug}</td>
                    <td>{category.createdAt}</td>
                    <td>{category.updatedAt}</td>
                    <td>
                      <Button
                        className="me-2"
                        variant="outline-dark"
                        onClick={() => handleShowEdit(category)}
                      >
                        <i className="bi bi-pencil fs-6"></i>
                      </Button>
                      <Button
                        variant="outline-secondary"
                        onClick={() => handleShowDestroy(category)}
                      >
                        <i className="bi bi-x-octagon-fill fs-6"></i>
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No se encontraron resultados</p>
          )}
        </div>
      </div>

      <Button
        variant="success"
        onClick={handleShowCreate}
        className="absolute-add-btn reounded-circle fs-5"
      >
        <i className="bi bi-plus-lg"></i>
      </Button>

      <CreateCategory
        showCreate={showCreate}
        setShowCreate={setShowCreate}
        token={token}
      />

      <EditCategory
        token={token}
        showEdit={showEdit}
        category={category}
        setShowEdit={setShowEdit}
        onHide={() => {
          setShowEdit(false);
        }}
      />

      <Modal className="modals" show={showDestroy} onHide={handleCloseDestroy}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Admin</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this category?</Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-danger"
            onClick={(e) => handleDestroyCategory(e)}
          >
            Accept
          </Button>
          <Button variant="outline-secondary" onClick={handleCloseDestroy}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default CategoriesPage;
